import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { clsx } from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { getTransferDetails } from 'entities/ticket/lib/getTransferDetails'
import { IFindTicketForm } from 'entities/ticket/models/find-ticket/models'
import { ShowCarrier, ShowInfoCard } from 'entities/ticket/ui/card-of-ticket/ui'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import {
  prepareShowListTicket,
  prepareTimeShow,
} from 'shared/lib//ticketRender'
import { showWrongDateFormat } from 'shared/lib/dateFormat'
import { TicketItem } from 'shared/models/ticket'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  countPassenger: number
  selectedTicket: TicketItem
  formFindTicket: IFindTicketForm
}

export const FlightInfoV2 = ({
  selectedTicket,
  countPassenger,
  formFindTicket,
}: Props) => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const onDetailTicket = () => {
    navigate(RoutingPaths.avia.purchase.tickerDetail.path())
  }

  const preparedTicket = prepareShowListTicket(selectedTicket, countPassenger)

  const departureCardCity = formFindTicket?.directions?.[0]

  const arriveCardCity = formFindTicket?.directions?.[0]

  const preparedDate = `${departureCardCity?.from?.cityName} - ${arriveCardCity?.to?.cityName}`

  const departureCardDate = showWrongDateFormat(
    departureCardCity?.date,
    DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY,
    ',',
  )

  const arriveCardDate = showWrongDateFormat(
    arriveCardCity?.back_date || '',
    DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY,
    ',',
  )

  let preparedCardInfo = `${departureCardDate} `

  if (arriveCardCity?.back_date) {
    preparedCardInfo += ` - ${arriveCardDate} `
  }

  preparedCardInfo += `• ${t('pass')} ${countPassenger}`
  return (
    <Paper
      padding={[16]}
      radius={16}
    >
      <div className={s.container}>
        <div className={s.header}>
          <p className={clsx('bold-17', s.title)}>{preparedDate}</p>

          <span className={clsx('regular-13', s.subTitle)}>
            {preparedCardInfo}
          </span>
        </div>

        {preparedTicket?.segments?.map((item, index) => {
          const timeFlight = prepareTimeShow(
            parseInt(`${item.time?.time || 0}`),
          )

          const timeFlightText = t('time_flight', {
            hours: timeFlight?.hours,
            minutes: timeFlight?.minutes,
          })

          const countTransfer = parseInt(item?.time?.countSegment || '0')
          return (
            <div
              className={s.bodySegment}
              key={index}
            >
              <div className={s.images}>
                <ShowCarrier carrier={item?.carrier} />
              </div>

              <div className={s.segments}>
                <ShowInfoCard
                  title={`${item?.from?.time}`}
                  subTitle={item?.from?.name}
                />
                <span className={s.divider}>-</span>
                <ShowInfoCard
                  title={`${item?.to?.time}`}
                  subTitle={item?.to?.name}
                />
              </div>

              <div className={s.duration}>
                <ShowInfoCard
                  title={timeFlightText}
                  subTitle={getTransferDetails(
                    countTransfer,
                    item.is_airport_change,
                    item.baggage_recheck,
                  )}
                />
              </div>
            </div>
          )
        })}

        <div className={s.active}>
          <span
            onClick={onDetailTicket}
            className={clsx('medium-15', s.text)}
          >
            {t('show_detail')}
          </span>
        </div>
      </div>
    </Paper>
  )
}
